import { TYPE as t } from "vue-toastification";
const o = {
  [t.SUCCESS]: { timeout: 5e3 },
  [t.WARNING]: { timeout: !1 },
  [t.INFO]: { timeout: !1 },
  [t.DEFAULT]: { timeout: 5e3 }
};
export {
  o as DEFAULT_TOAST_TIMEOUTS
};
//# sourceMappingURL=default-toast-timeouts.js.map
